import { oivCoreSharedFeature } from './oiv-core-shared.reducer';

const selectSource = oivCoreSharedFeature.selectSource;
const selectLinks = oivCoreSharedFeature.selectLinks;
const selectLanguage = oivCoreSharedFeature.selectLanguage;
const selectIsMobileMode = oivCoreSharedFeature.selectIsMobileMode;
const selectIsApprovalMode = oivCoreSharedFeature.selectIsApprovalMode;
const selectAlerts = oivCoreSharedFeature.selectAlerts;
const selectIsOverlayOpen = oivCoreSharedFeature.selectIsOverlayOpen;

export const fromOivCoreShared = {
    selectSource,
    selectLanguage,
    selectIsMobileMode,
    selectIsApprovalMode,
    selectAlerts,
    selectIsOverlayOpen,
    selectLinks,
};
